import { $html } from '../utils/dom';

export class Color {
  static colors = ['#19F3FF', '#ffd600', '#72d903', '#a953ff', '#ff3254', '#ff5000'];

  // =============================================================================
  // Lifecycle
  // =============================================================================
  static init() {
    $html.style.setProperty('--placeholder-color', this.generateColor());
  }

  static generateColor() {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }
}
